import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Logo from '../Images/FullLogo_NoBuffer__4_-removebg-preview.png'
import { useSelector } from 'react-redux'
import { authenticateSelector } from '../api/userAuth'

const HIDE_AFTER = 380 // banner height in px

const Navbar = () => {
  const { isAuthenticate } = useSelector(authenticateSelector)
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setHidden(window.scrollY > HIDE_AFTER)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header
  className={`
    fixed top-0 left-0 w-full z-50
    bg-gradient-to-r from-blue-400 to-blue-300
    transform-gpu will-change-transform
    transition-transform transition-opacity duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
    ${hidden ? '-translate-y-full opacity-0' : 'translate-y-0 opacity-100'}
  `}
>

      <div className="container mx-auto flex justify-between items-center p-4">
        <Link to="/" className="flex items-center">
          <img src={Logo} alt="Logo" className="h-14 w-auto mr-2" />
          <span className="text-2xl font-bold font-serif">The Great Himalayas</span>
        </Link>

        <nav>
          <ul className="flex space-x-4">
            <li><Link to="/" className="nav-link">Home</Link></li>
            <li><Link to="/bookCabs" className="nav-link">Cabs</Link></li>
            <li><Link to="/packages" className="nav-link">Tours</Link></li>
            <li><Link to="/hotels" className="nav-link">Stays</Link></li>
            <li><Link to="/wellness" className="nav-link">Retreats</Link></li>
            <li><Link to="/careers" className="nav-link">Careers</Link></li>
            <li>
              <Link to="/userprofile" className="nav-link">
                {isAuthenticate ? 'Profile' : 'Login'}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Navbar
